export class CheckClientsResModel {
  idCliente: number;
  codigo: string;
  mensaje: string;

  constructor( obj: {
    idCliente: number;
    codigo: string;
    mensaje: string;
  } ) {
    this.idCliente = obj.idCliente;
    this.codigo = obj.codigo;
    this.mensaje = obj.mensaje;
  }
}
